/** @module MaterialSpec/MPPColorsMatrix */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/table/matrix/ColumnAssociation"
], function(declare,_,ColumnAssociation) {

	return declare(ColumnAssociation, {
		availableColumnStoreProperty: "bomColorStore",
		columnAssociation: "MPCColorway",
		columnPath: "Child:ColorColorways",
		selectedColumnValueProperty: "bomActiveColorURLs",
		bAllowColumnFilter: true
	});
});
